import {
  AdgroupFormData,
  CampaignFormData,
  FullNormalFormData,
  CreativeToolName,
  CreativeToolRenderMode
} from '@tt4b/ttam-enums';
import {
  StateEnum,
  useCreativeToolEntranceCode,
  useCreativeToolInit,
  useGlobalVariableControl,
  useStore
} from '@tt4b/ttam-hooks';
import { getIframeId, getInstantPageEditorFrameInitData } from '@tt4b/ttam-utils';
import { computed, Ref, ref } from '@vue/composition-api';

export const useCreativeToolInOneUrl = () => '/video_kit/choose';

/**
 * 视频创意工具（4 in 1）是否可见
 */
export function usePropsCreativeToolInOneVisible() {
  const { variable: visible, setter } = useGlobalVariableControl(CreativeToolName.creativeToolInOne);

  const open = () => setter(true);
  const close = () => setter(false);

  return {
    visible,
    open,
    close,
  };
}

/**
 * 视频创意工具（4 in 1）编辑器语言
 */
export function usePropsCreativeToolInOneLang() {
  const { state } = useStore();
  const lang = computed(() => state[StateEnum.baseInfo].value.lang);
  return {
    lang,
  };
}

/**
 * 视频创意工具（4 in 1）初始化方法
 */
export function usePropsCreativeToolInOneInitMethod(options: {
  creativeUuid: Ref<string>;
  campaignData: Ref<CampaignFormData>;
  adgroupData: Ref<AdgroupFormData>;
  creativeData: Ref<FullNormalFormData>;
}) {
  const { campaignData, adgroupData, creativeData, creativeUuid } = options;

  const { entranceCode } = useCreativeToolEntranceCode({
    isEdit: computed(() => false),
    isCopy: computed(() => false),
    adgroupFormData: adgroupData,
  });

  const { initOptimizeObjectData } = useCreativeToolInit({
    creationUuid: creativeUuid.value,
    origin: computed(() => 'create'),
    entranceCode,
    campaignFormData: campaignData,
    adgroupFormData: adgroupData,
    creativeFormData: creativeData,
  });

  function initDataMethod() {
    const data = {
      ...getInstantPageEditorFrameInitData({}),
      ...initOptimizeObjectData(),
      id: creativeUuid.value,
      maxnum: 10,
      isAbTest: true, // todo spf
      renderMode: CreativeToolRenderMode.withPlatform,
    };
    return data;
  }

  return {
    initDataMethod,
  };
}
